import React, { useEffect, useRef, useState } from "react"
import { searchIcon } from "components/Icons"
import cx from "classnames"

export default function SearchInput({
  value, setValue, handleSubmit, placeholder, dataProcessing, disableSubmit
}) {
  const containerRef = useRef(null)
  const inputRef = useRef(null)
  const [searchInputActive, setSearchInputActive] = useState(!!value)

  useEffect(() => {
    if (value) {
      setSearchInputActive(true)
    }
  }, [value])

  const activateSearch = () => {
    setSearchInputActive(true)
    window.requestAnimationFrame(() => {
      inputRef.current?.focus()
    })
  }

  const handleContainerBlur = e => {
    if (containerRef.current?.contains(e.relatedTarget)) {
      return
    }

    window.setTimeout(() => {
      if (containerRef.current?.contains(document.activeElement)) {
        return
      }
      const currentValue = inputRef.current?.value?.trim()
      if (currentValue) {
        return
      }
      setSearchInputActive(false)
    }, 150)
  }

  const onFormSubmit = e => {
    e.preventDefault()
    if (handleSubmit) {
      handleSubmit(e)
    }
  }

  return (
    <form className="search-form" onSubmit={onFormSubmit}>
      <div
        ref={containerRef}
        className={cx("btn btn-lg rounded-pill search-input", { active: searchInputActive })}
        onFocus={activateSearch}
        onMouseEnter={() => { setSearchInputActive(true) }}
        onBlur={handleContainerBlur}
        onClick={() => {
          if (!searchInputActive) {
            activateSearch()
          }
        }}
        onKeyDown={e => {
          if (e.key === "Enter" && !searchInputActive) {
            activateSearch()
          }
        }}
        role="search">
        <input
          ref={inputRef}
          className={searchInputActive ? "mr-2" : ""}
          type="search"
          enterKeyHint="search"
          placeholder={placeholder || "Search by job no, name or address"}
          value={value || ""}
          onChange={e => {
            setSearchInputActive(true)
            setValue(e.target.value)
          }}
          onFocus={() => { setSearchInputActive(true) }}
          disabled={!!dataProcessing} />
        <button
          type="submit"
          disabled={disableSubmit || !!dataProcessing}
          onMouseDown={e => {
            e.preventDefault()
          }}
          onClick={() => {
            setSearchInputActive(true)
          }}>
          <img src={searchIcon} alt="" />
        </button>
      </div>
    </form>
  )
}
